export default __webpack_public_path__ + "static/img/vogue_scene_animated_0380.91e96ef.webp";